import { Toaster } from "sonner";

export const toastStyles = {
  success: {
    background: "#22C55E",
    color: "#FFFFFF",
  },
  error: {
    background: "#DC2626",
    color: "#FAFAFA",
  },
  warning: {
    background: "#F97316",
    color: "#FFFFFF",
  },
};

export const BUTTON_STYLE =
  "border border-white rounded-[6px] px-3 py-1 font-bold text-zinc-50 text-sm ml-auto cursor-pointer whitespace-nowrap";

export const TITLE_STYLE = "mb-1 text-sm font-bold";

const ToastCustom = () => {
  return (
    <Toaster
      position="top-right"
      richColors
      offset={{ top: "65px", right: "40px" }}
      icons={{ success: null, warning: null, error: null, info: null }}
      expand
      visibleToasts={5}
      toastOptions={{
        style: {
          fontSize: "12px",
          padding: "16px",
          fontWeight: 400,
          width: "388px",
        },
      }}
    />
  );
};

export default ToastCustom;
